import {
    CREATE_STITCHING_INWARD_DETAILS_REQUEST_DK,
    CREATE_STITCHING_INWARD_DETAILS_SUCCESS_DK,
    CREATE_STITCHING_INWARD_DETAILS_FAILURE_DK,
    DELETE_STITCHING_INWARD_DETAILS_REQUEST_DK,
    DELETE_STITCHING_INWARD_DETAILS_SUCCESS_DK,
    DELETE_STITCHING_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_STITCHING_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_STITCHING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_STITCHING_INWARD_DETAILS_FAILURE_DK,
    FETCH_STITCHING_INWARD_DETAILS_REQUEST_DK,
    FETCH_STITCHING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_STITCHING_INWARD_DETAILS_FAILURE_DK,
    UPDATE_STITCHING_INWARD_DETAILS_REQUEST_DK,
    UPDATE_STITCHING_INWARD_DETAILS_SUCCESS_DK,
    UPDATE_STITCHING_INWARD_DETAILS_FAILURE_DK,
    RESET_STITCHING_INWARD_DETAILS_INFO_DK,
    CREATE_STITCHING_INWARD_DETAILS_FORM_DK,
    UPDATE_STITCHING_INWARD_DETAILS_FORM_DK,
    FETCH_STITCHING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_FAILURE_DK
} from './stitchingInwardDetails.actionsType';

export const STITCHING_INWARD_DK_DETAILS = 'stitchingInwardDKDetails';

let initialState = {
    loading: false,
    stitchingInwardDetails: [],
    stitchingInwardDetailsWithoutId: [],
    previousGetList: [],
    stitchingInwardDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        // fldReceivingRolls: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let stitchingInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STITCHING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_REQUEST_DK:
        case CREATE_STITCHING_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_STITCHING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_STITCHING_INWARD_DETAILS_REQUEST_DK:
        case DELETE_STITCHING_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_STITCHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.IPI
            };
        case FETCH_STITCHING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsWithoutId: updatePayload
            };
        case CREATE_STITCHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case UPDATE_STITCHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case FETCH_SINGLE_STITCHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsForm: updatePayload
            };
        case DELETE_STITCHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case RESET_STITCHING_INWARD_DETAILS_INFO_DK:
            return {
                ...state,
                stitchingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case CREATE_STITCHING_INWARD_DETAILS_FORM_DK:
        case UPDATE_STITCHING_INWARD_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsForm: {
                    ...state.stitchingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_STITCHING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_FAILURE_DK:
        case CREATE_STITCHING_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_STITCHING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_STITCHING_INWARD_DETAILS_FAILURE_DK:
        case DELETE_STITCHING_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
